import { Grid } from '@material-ui/core';
import { Dropdown } from '@WESCO-International/wdp-ui-components/components/dropdown/Dropdown';
import { MultiSelect } from '@WESCO-International/wdp-ui-components/components/multiselect';
import { FormField } from '../common/FormField';
import type { DropdownOption } from '../common/types';

interface ComponentRelationsSectionProps {
  consumesApis: string[];
  providesApis: string[];
  subcomponentOf: string;
  consumesSearch: string;
  providesSearch: string;
  apiStringOptions: string[];
  componentDropdownOptions: DropdownOption[];
  onConsumesChange: (selected: string[]) => void;
  onProvidesChange: (selected: string[]) => void;
  onSubcomponentChange: (value: string) => void;
  onConsumesSearchChange: (value: string) => void;
  onProvidesSearchChange: (value: string) => void;
}

export const ComponentRelationsSection = ({
  consumesApis,
  providesApis,
  subcomponentOf,
  consumesSearch,
  providesSearch,
  apiStringOptions,
  componentDropdownOptions,
  onConsumesChange,
  onProvidesChange,
  onSubcomponentChange,
  onConsumesSearchChange,
  onProvidesSearchChange,
}: ComponentRelationsSectionProps) => (
  <div className="formSection">
    <h6 className="wdp-heading s-6 semibold" style={{ marginBottom: 12 }}>
      Component Relations
    </h6>
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <FormField label="Consumed">
          <MultiSelect
            value={consumesSearch}
            handleChange={(v: any) =>
              onConsumesSearchChange(
                typeof v === 'string' ? v : v?.target?.value ?? '',
              )
            }
            selected={consumesApis}
            options={apiStringOptions}
            optionsType="string"
            filter="contains"
            handleSelect={selected => {
              const next = (selected as string[]) ?? [];
              onConsumesChange(next);
              onConsumesSearchChange('');
            }}
            placeholder="Search APIs"
            defaultLabel="Select APIs consumed"
            searchable
            searchType="popover"
            size="medium"
          />
        </FormField>
      </Grid>

      <Grid item xs={12} md={4}>
        <FormField label="Provided">
          <MultiSelect
            value={providesSearch}
            handleChange={(v: any) =>
              onProvidesSearchChange(
                typeof v === 'string' ? v : v?.target?.value ?? '',
              )
            }
            selected={providesApis}
            options={apiStringOptions}
            optionsType="string"
            filter="contains"
            handleSelect={selected => {
              const next = (selected as string[]) ?? [];
              onProvidesChange(next);
              onProvidesSearchChange('');
            }}
            placeholder="Search APIs"
            defaultLabel="Select APIs provided"
            searchable
            searchType="popover"
            size="medium"
          />
        </FormField>
      </Grid>

      <Grid item xs={12} md={4}>
        <FormField label="Link Sub-Components">
          <Dropdown
            value={subcomponentOf}
            options={componentDropdownOptions}
            emptyLabel="Select parent component"
            onChange={(opt: any) => onSubcomponentChange(opt?.value ?? '')}
          />
        </FormField>
      </Grid>
    </Grid>
  </div>
);
